import { useQuery } from "@apollo/client";
import { SxProps } from "@mui/system";
import { Accessor } from "mt-components";
import { gql } from "../../__generated__";
import capitalizeFirstLetter from "../../helpers/capitalize-first-letter";
import Select from "../Select";

type CountrySelectorProps = Accessor<string, "country"> & { sx?: SxProps };

export default function CountrySelector(props: CountrySelectorProps) {
  const { loading, error, data } = useQuery(GET_COUNTRIES);
  if (error) return <>Error {error.message}</>;

  const options =
    data?.locations.records.map((location) => ({
      id: location.id,
      name: capitalizeFirstLetter(location.slug),
    })) || [];

  return (
    <Select
      sx={{ width: "120px", ...props.sx }}
      size="small"
      hideNone
      loading={loading}
      label="Country"
      value={props.country}
      onChange={props.setCountry}
      options={[{ id: "", name: <em>any</em> }, ...options]}
    />
  );
}

const GET_COUNTRIES = gql(`
  query GetCountries {
    locations(input: { locationType: COUNTRY }) {
      records {
        id
        slug
      }
    }
  }
`);
